import {APPLICATION_FILE_SIZE_LIMIT, CV_FILE_EXTENSIONS, OTHER_FILE_EXTENSIONS, JobApplication, REDIRECT, SUCCESS_REPONSE_CODE, UNPROCESSABLE_ENTITY_RESPONSE_CODE, handleOtherResponseCode, toastr, CustomToastrAction, CommonAction, QUESTION_TYPES} from '@/imports-files/pages/career/view-job';


export function onApplyClick(event, router){
  document.getElementsByClassName('job-description-section')[0].classList.add('dnone');
  document.getElementsByClassName('job-apply-section')[0].classList.remove('dnone');
  document.getElementsByClassName('job-apply-button')[0].classList.add('dnone');
  document.getElementsByClassName('job-description-button')[0].classList.remove('dnone');
  //This considiton is to prevent the page looping 
  if(event != 'useEffect')
  {
    // let queryParams =  router.query;
    // delete queryParams.q
    // delete queryParams.client_slug
    // delete queryParams.slug
    // queryParams['q'] = 'apply';
    // router.push({
    //                         pathname :  router.asPath.split('?')[0],
    //                         query    :  queryParams
    //                     })      

    // Construct URLSearchParams object instance from current URL querystring.
var queryParams = new URLSearchParams(window.location.search);
 
// Set new or modify existing parameter value. 
queryParams.set("q", "apply");
 
// Replace current querystring with the new one.
history.replaceState(null, null, "?"+queryParams.toString());

  }
}

export function viewDescription(event, formik, router)
{
  document.getElementsByClassName('job-description-section')[0].classList.remove('dnone');
  document.getElementsByClassName('job-apply-section')[0].classList.add('dnone');
  document.getElementsByClassName('job-apply-button')[0].classList.remove('dnone');
  document.getElementsByClassName('job-description-button')[0].classList.add('dnone');
  formik.current.setErrors({});

  // let queryParams =  router.query;
  //  delete queryParams.q
  // delete queryParams.client_slug
  // delete queryParams.slug
  // queryParams['q'] = 'desc';
  // router.push({
  //                           pathname :  router.asPath.split('?')[0],
  //                           query    :  queryParams
  //                       }) 

      // Construct URLSearchParams object instance from current URL querystring.
var queryParams = new URLSearchParams(window.location.search);
 
// Set new or modify existing parameter value. 
queryParams.set("q", "desc");
 
// Replace current querystring with the new one.
history.replaceState(null, null, "?"+queryParams.toString());

}

export function updateApplicationData(mutationRecords, router, title, setApplied){
  let mutationRecord = mutationRecords[0]
  let oldValue = mutationRecord.oldValue;
  let newValue = mutationRecord.target.getAttribute('class')
  if(oldValue.includes('indeed-apply-status-not-applied') && newValue.includes("indeed-apply-status-applied")){
    setApplied(true)
  }
}

export function updatePage(mutationRecords, router, title){
    let mutationRecord = mutationRecords[0]
    let oldValue = mutationRecord.oldValue;
    let newValue = mutationRecord.target.getAttribute('style')
    if(!oldValue.includes('display: none;') && newValue.includes('display: none;')){
      router.push(REDIRECT.client.jobs.application_sent + `?with_indeed=true&title=${title}`)
    }
  }

export async function parseResume(file, file_name, formik)
{
  const formData = new FormData();
  formData.append("file", file, file_name)
  const result = await new JobApplication().parseCV(formData)
  const status_code = result.status || result.response.status;
  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
    const response = result.data;
      if(formik.values.job_application)
      {
        if(response.name) formik.setFieldValue('job_application.name', response.name || '')
        if(response.first_name) formik.setFieldValue('job_application.first_name', response.first_name || '')
        if(response.last_name) formik.setFieldValue('job_application.last_name', response.last_name || '')
        if(response.email) formik.setFieldValue('job_application.email', response.email || '')
        if(response.contact_no) formik.setFieldValue('job_application.contact_no', response.contact_no || '')
      }
      else if(formik.values.client_candidate){
        if(response.name) formik.setFieldValue('client_candidate.name', response.name || '')
        if(response.first_name) formik.setFieldValue('client_candidate.first_name', response.first_name || '')
        if(response.last_name) formik.setFieldValue('client_candidate.last_name', response.last_name || '')
        if(response.email) formik.setFieldValue('client_candidate.email', response.email || '')
        if(response.contact_no) formik.setFieldValue('client_candidate.contact_no', response.contact_no || '')
      }
    break;
  case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    new CustomToastrAction().setNormalToastr(result.response.data.error, 'warning');
    // toastr.warning(result.response.data.error)
    return result.response.data.error
  default: 
    handleOtherResponseCode(status_code) 
  } 

}

export async function handleFormSubmit(values, router, job_slug, setConfirmModal, setShowLoader, source, setDuplicateEmail)
{
  setConfirmModal(false);
  setShowLoader(true);
  const formData = new FormData();
  formData.append("job_application[first_name]",  values.job_application.first_name)
  formData.append("job_application[last_name]",  values.job_application.last_name)
  formData.append("job_application[candidate_linkedin_url]",  values.job_application.candidate_linkedin_url)
  formData.append("job_application[portfolio_url]",  values.job_application.portfolio_url)
  formData.append("job_application[email]", values.job_application.email)
  formData.append("job_application[contact_no]", values.job_application.contact_no)
  formData.append("job_application[source]",  'Direct')
  formData.append("job_application[terms_accepted]", values.job_application.terms_accepted)
 
  if (values.job_application.cv_library_token && values.job_application.cv_library_filename)
  {
    formData.append("job_application[cv_library_token]",  values.job_application.cv_library_token)
    formData.append("job_application[cv_library_file_name]",  values.job_application.cv_library_filename)
  }
  else if(values.job_application.resume_attributes.file && values.job_application.resume_attributes.file_name)
  {
    formData.append("job_application[candidate_cv]", values.job_application.resume_attributes.file,
    values.job_application.resume_attributes.file_name
    );
  }

  values.job_application.job_application_files_attributes.map((file, index) => {
    formData.append(`job_application[other_files_attributes][${index}][file_type]`, file.file_type)
    formData.append(`job_application[other_files_attributes][${index}][file]`, file.file, file.file_name)
    return file;
  })

  if(source.length > 0) formData.append("job_application[job_board_slug]", source.toLowerCase())
  
  if( document.referrer!='' && !document.referrer.includes(getSource()) && (source != ''|| source!=null || typeof source != 'undefined'))
  {
    formData.append("job_application[job_board_domain]", document.referrer)
  }

  values.job_application.screening_answers_attributes.map((screening_answer, index) => {
    formData.append(`job_application[screening_answers_attributes][${index}][text]`, screening_answer.text)
    formData.append(`job_application[screening_answers_attributes][${index}][screening_question_id]`, screening_answer.screening_question_id)
    screening_answer.options.forEach(item => {
      formData.append(`job_application[screening_answers_attributes][${index}][options][]`, item);
    });
    return screening_answer;
  })

  const result      = await new JobApplication().applyJob(formData, job_slug)
  const status_code = result.status || result.response.status;
  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
    const response = result.data;
    if(response.success)
    {
      setConfirmModal(false);
      setShowLoader(true);
       window.location.replace(REDIRECT.client.jobs.application_sent + `?token=${response.token}`)
      // router.push(REDIRECT.client.jobs.application_sent + `?application_id=${response.id}`)
      new CustomToastrAction().setNormalToastr(response.success, 'success');
      // toastr.success(response.success)
    }
    break;
  case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    setConfirmModal(false)
    setShowLoader(false);
    if(result.response.data.message) setDuplicateEmail({state: true, message: result.response.data.message})
    return result.response.data.error
  default: 
    handleOtherResponseCode(status_code) 
  } 
}

export async function onFileChange(files, formik, type, isAutofill, from, setCvErrorMessage, setOtherErrorMessage, setFileCount, setShowLoader, setIsDisabled)
{
  let start_index = ''

  if(formik.values.job_application)
  {
    start_index = formik.values.job_application.job_application_files_attributes?.length > 0 ? formik.values.job_application.job_application_files_attributes.length : 0
    
    formik?.errors?.job_application?.resume_attributes ? formik.errors.job_application.resume_attributes = '' : '';
    formik.setErrors({'job_application': formik.errors.job_application});
    setCvErrorMessage('');
    setFileCount(Math.random() * 10000);
  }
  else
  {
    start_index = formik.values.client_candidate.other_files_attributes?.length > 0 ? formik.values.client_candidate.other_files_attributes.length : 0
  }


  let reject_files = []
  if(['drive', 'dropbox'].includes(from)){
      reject_files = [...files].filter((x) =>  x.fileBlob.size > APPLICATION_FILE_SIZE_LIMIT )
    }
  else{
    reject_files = [...files].filter((x) => x.size > APPLICATION_FILE_SIZE_LIMIT)
  }


  if(reject_files.length > 0) {
    if(type == "other") setOtherErrorMessage('One or more files size is more than 25 MB.')
    else if(type == "cv") setCvErrorMessage('File size is more than 25 MB.')
    return false;
  }


  if(['drive', 'dropbox'].includes(from)){
    reject_files = [...files].filter((x) => 
      {
       let file_extension = x.fileName.split('.').pop().toLowerCase() 
       let extension  = (type == "cv") ? CV_FILE_EXTENSIONS.includes(file_extension) :  OTHER_FILE_EXTENSIONS.includes(file_extension)
      return  !extension

      })
  }
  else{
    reject_files = [...files].filter((x) => {
      let file_extension = x.name.split('.').pop().toLowerCase() 
      let extension  = (type == "cv") ? CV_FILE_EXTENSIONS.includes(file_extension) :  OTHER_FILE_EXTENSIONS.includes(file_extension)
      return  !extension
    })
  }

  if(reject_files.length > 0) {
    if(type == "other") setOtherErrorMessage('One or more files types are not allowed.')
    else if(type == "cv") setCvErrorMessage('File type is not allowed.')
    return false;
  }

  if(type == "cv" && files.length > 0)
  {
    setIsDisabled(true)
    if(['drive', 'dropbox'].includes(from))
    { addCV(formik, files[0].fileBlob, files[0].fileName, setCvErrorMessage, setFileCount)}
    else 
    { addCV(formik, files[0], files[0].name, setCvErrorMessage, setFileCount) }
  }
  else if(type == "other" && files.length > 0)
  {
    if(start_index >= 5 || (start_index + files.length) > 5){
      setOtherErrorMessage('Maximum no of files allowed is 5.')
      return false;
    }
    for (let i = 0; i < files.length; i++) {
      if(start_index < 5){
        if(['drive', 'dropbox'].includes(from)){ addFile(formik, files[i].fileBlob, files[i].fileName, setOtherErrorMessage, setFileCount)}
        else { addFile(formik, files[i], files[i].name, setOtherErrorMessage, setFileCount) }
        start_index += 1;  
      }
    }
  }
  if(isAutofill)
  {
    if(files.length > 0)
    {
      setShowLoader(true);
      if(['drive', 'dropbox'].includes(from))
      { 
        await parseResume(files[0].fileBlob, files[0].fileName, formik);
        setShowLoader(false);
      }
      else 
      { 
        await parseResume(files[0], files[0].name, formik);
        setShowLoader(false);
      }
    }
  }
}

function addFile(formik, file, file_name, setOtherErrorMessage, setFileCount){
  let hash = { 
        file_type: 'other',
        file: file,
        file_name: file_name,
        file_size: file.size
     }

  if(formik.values.job_application)
  {
    formik.values.job_application.job_application_files_attributes.push(hash)
  }
  else
  {
    formik.values.client_candidate.other_files_attributes.push(hash)
  }
  setOtherErrorMessage('');
  setFileCount(Math.random() * 10000)
}
function addCV(formik, file, file_name, setCvErrorMessage, setFileCount)
{
  let hash = { 
        file_type: 'cv',
        file: file,
        file_name: file_name,
        file_size: file.size
     }
  
  if(formik.values.job_application)
  {
    formik.values.job_application.resume_attributes = hash
  }
  else
  {
    formik.values.client_candidate.resume_attributes = hash
  }

  
  setCvErrorMessage('')
  setFileCount(Math.random() * 10000)
}

export async function jobApplicationTokenSubmit(router, setConfirmState){
  const params = {token: router.query.token}
  setConfirmState(true)
  const result = await new JobApplication().confirmEmail(params)
  const status_code = result.status || result.response.status;
  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
      const response = result.data 
      return response
    case UNPROCESSABLE_ENTITY_RESPONSE_CODE: 
      return result.response.data
    default: 
      handleOtherResponseCode(status_code)
  }
}

  export function copyToClipboard(link, setClipBoardMessage)
  {
    var textField = document.createElement('textarea')
    textField.innerText = link
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()
    setClipBoardMessage('Copied');
    document.querySelector('.ClipboardTooltip').lastChild.textContent = 'Copied'
    // toastr.success('Copied')
  }


export function onRemoveFile(formik, type, index, setCvErrorMessage, setOtherErrorMessage, setFileCount, setIsDisabled)
{
  if(type == "cv")
  {
    let hash = {
      file_type: '',
      file: '',
      file_name: ''
    }
    setIsDisabled(false)
    formik.setFieldValue('job_application.resume_attributes', hash);
    setCvErrorMessage('');
  }
  else{
    formik.values.job_application?.job_application_files_attributes?.splice(index, 1);
    setOtherErrorMessage('')
    setFileCount(Math.random() * 10000);
  }
}


export function closeDropDown(setIsActive){
  setTimeout(()=> setIsActive(false), 50)
}

export function onCancel(){
  return false;
}

export function otherErrors(otherErrorMessage, errors)
{
  return otherErrorMessage || errors?.job_application?.job_application_files_attributes || ''
}

export function cvErrors(cvErrorMessage, errors)
{

  return cvErrorMessage || errors?.job_application?.resume_attributes?.file_name || errors?.job_application?.resume_attributes?.base || ''
}

export function activeViewClass(activeView, section){
  return activeView == section ? ''  :  'dnone'
}


export function without_cv_condition_passes(formik)
{
  if (formik.current.values.job_application.without_cv)
  {
    let profile_url_present = formik.current.values.job_application.portfolio_url == '' ? false : true;
    let resume_present      = formik.current.values.job_application.resume_attributes.file_name == '' ? false : true ;
    return profile_url_present || resume_present;
  }
  else
  {
    return true;
  }
}

export function getSource()
{
  var parent_domain = '';
  var hostname = window.location.hostname.split('.');
  parent_domain = parent_domain + hostname[hostname.length - 1] + hostname[hostname.length - 2]
  return parent_domain
}

export function getReffereParentDomain(refferName)
{
  var parent_domain = '';
  var hostname  = refferName.split('.');
  parent_domain = parent_domain + hostname[hostname.length - 1] + hostname[hostname.length - 2]
  return parent_domain
}

export function redirectToCarrerPage(client_slug){
  const careerUrl = REDIRECT.client.jobs.view_career_page;
  redirectToUrl(client_slug, careerUrl);
}

export function redirectToCustomUrl(url) {
  if (!/^https?:\/\//i.test(url)) {
      // Add "http://" as the default if no protocol is found
    url = 'http://' + url;
  }
  window.open(url, "_self");
}

function redirectToUrl(client_slug, relativeUrl) {
  const protocol = window.location.protocol;
  const hostnameArray = window.location.host.split(".");
  hostnameArray[0] = client_slug;
  const url = protocol + "//" + hostnameArray.join(".") + relativeUrl;
  window.open(url, "_self");
}

export async function  submitScreeningQuestions(args, router, job_id, setShowLoader, setSuccessFailure) {
  setShowLoader(true);
  const result      = await new JobApplication().submitAnswers(args, job_id)
  const status_code = result.status || result.response.status;
  switch (status_code)
  {
    case SUCCESS_REPONSE_CODE:
    const response = result.data;
    if(response.success)
    {
      setShowLoader(false);
      setSuccessFailure({status_code: 201, error: 'This tab can now be closed safely.'})
      new CustomToastrAction().setNormalToastr(response.success, 'success');
    }
    break;
  case UNPROCESSABLE_ENTITY_RESPONSE_CODE:
    setShowLoader(false);
    new CustomToastrAction().setNormalToastr(result.response.data.error, 'error');
  default:
    handleOtherResponseCode(status_code)
  }
}

export function validAnswers(formik) {
  let isValid = true
  for (var i = 0; i < formik.values.job_application.screening_answers_attributes.length; i++) {
    let question = formik.values.job_application.screening_answers_attributes[i]
    if(question.mandatory){
      switch(question.question_type_name){
      case QUESTION_TYPES.SINGLE_LINE: case QUESTION_TYPES.MULTIPLE_LINE:
        isValid = question.text.length > 0 ? true : false
        break;
      default:
        isValid = question.options.length > 0 ? true : false
        break;
      }
    }
    else{
      continue;
    }
    if(!isValid) break;
  }
  return isValid
}